'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDataflow = undefined;

var _join = require('ramda/src/join');

var _join2 = _interopRequireDefault(_join);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require('recompose');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withDataflow = function withDataflow(Component) {
  return (0, _recompose.compose)((0, _recompose.mapProps)(function (_ref) {
    var description = _ref.description,
        dimensionLabel = _ref.dimensionLabel,
        matches = _ref.matches,
        title = _ref.title,
        topics = _ref.topics,
        rest = _objectWithoutProperties(_ref, ['description', 'dimensionLabel', 'matches', 'title', 'topics']);

    return _extends({}, rest, {
      matches: (0, _utils.parseMatches)(matches, dimensionLabel),
      title: (0, _utils.parseHighlight)((0, _utils.removeIdFromTitle)(title)),
      topics: (0, _utils.parseHighlight)((0, _join2.default)(' - ', topics)),
      description: (0, _utils.parseHighlight)(description)
    });
  }))(Component);
};
exports.withDataflow = withDataflow;


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-dataflow/with-dataflow.js
// module id = 2019
// module chunks = 0